import type { WhitelabelVariantDefinition } from '../../types';

export const fcrWhitelabel = {
  id: 'fcr-be',
  colors: {
    primary: {
      900: '#006F7E',
      800: '#008091',
      700: '#00ABC2',
      500: '#63CCDA',
      300: '#A8E3EA',
      100: '#E5F7F9',
      contrastText: '#FFFFFF',
    },
  },
} as const;

export const fcrDefaultTheme: WhitelabelVariantDefinition = {
  palette: {
    primary: {
      darker: fcrWhitelabel.colors.primary[900],
      dark: fcrWhitelabel.colors.primary[800],
      main: fcrWhitelabel.colors.primary[700],
      light: fcrWhitelabel.colors.primary[500],
      lighter: fcrWhitelabel.colors.primary[300],
      muted: fcrWhitelabel.colors.primary[100],
      contrastText: fcrWhitelabel.colors.primary.contrastText,
    },
  },
};
